module.exports = __webpack_public_path__ + "static/img/zhuanjiajieduBg.65409f05.png";